module.exports = __webpack_public_path__ + "assets/bab1f7773627d1cce36cd7233f4b35e4.png";